import {Component, OnInit} from '@angular/core';
import {CrudEdit} from '../../../../shared/components/crud-edit';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute, Route, Router} from '@angular/router';
import {ApiFactoryService} from '../../../../shared/services/api-factory.service';
import {AbstractBffApi} from '../../../../models/sharedinterface';
import {CrudCompaniesService} from '../../../../shared/services/crud-companies.service';
import {IDropdownSettings} from 'ng-multiselect-dropdown';
import {CrudMarketsService} from '@shared/services/crud-markets.service';
import {ShareddataService} from '@shared/services/shareddata.service';
import {AbstractCrudEditComponent} from '../../../../shared/library/crud-library/abstract-crud-edit.component';
import {CrudMarketgroupsService} from '../../../../shared/services/crud-marketgroups.service';
import {CrudFlagsService} from '../../../../shared/services/crud-flags.service';
import {AlertService} from '../../../../shared/services/alert.service';
import {FormlyFieldConfig} from '@ngx-formly/core';

@Component({
  selector: 'app-companies-edit',
  templateUrl: './companies-edit.component.html',
  styleUrls: ['./companies-edit.component.scss']
})
export class CompaniesEditComponent extends AbstractCrudEditComponent implements OnInit {

  public parentid: string;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    private companyService: CrudCompaniesService,
    private marketService: CrudMarketsService,
    protected route: ActivatedRoute,
    protected apifactory: ApiFactoryService,
    protected alertService: AlertService
  ) {
    super(activatedRoute, router, apifactory, companyService, alertService);

    this.fields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'base_fkid',
                type: 'input',
                templateOptions: {
                  label: 'Parent company',
                  readonly: true
                },
                hide: true
              },
              {
                key: 'label',
                type: 'input',
                templateOptions: {
                  label: 'Name',
                  required: true
                }
              },
              {
                key: 'variantlabel',
                type: 'input',
                templateOptions: {
                  label: 'Variant label',
                  required: true
                }
              },
              {
                key: 'nr',
                type: 'input',
                templateOptions: {
                  label: 'Nr',
                  required: !this.entityid ? true : false,
                },
                hideExpression: 'this.entityid'
              },
              {
                key: 'fullnr',
                type: 'input',
                templateOptions: {
                  label: 'Full Nr',
                  required: this.entityid ? true : false
                },
                hideExpression: '!this.entityid'
              },
              {
                key: 'previousFullnr',
                type: 'input',
                templateOptions: {
                  label: 'Previous Full Nr',
                  readonly: true
                },
                hide: true
              },

              {
                key: 'label1',
                type: 'input',
                templateOptions: {
                  label: 'Additional line 1'
                }
              },
              {
                key: 'label2',
                type: 'input',
                templateOptions: {
                  label: 'Additional line 2'
                }
              },
              {
                key: 'street',
                type: 'input',
                templateOptions: {
                  label: 'Street'
                }
              },
              {
                key: 'pobox',
                type: 'input',
                templateOptions: {
                  label: 'PO Box'
                }
              },
              {
                key: 'zip',
                type: 'input',
                templateOptions: {
                  label: 'ZIP'
                }
              },
              {
                key: 'place',
                type: 'input',
                templateOptions: {
                  label: 'Place'
                }
              },
              {
                key: 'state',
                type: 'input',
                templateOptions: {
                  label: 'State'
                }
              },
              {
                key: 'country',
                type: 'ng-select',
                defaultValue: 0,
                templateOptions: { label: 'Country', required: true, closeOnSelect: true },
                hooks: {
                  onInit: this.initCountryList
                }
              },
              {
                key: 'phone',
                type: 'input',
                templateOptions: {
                  label: 'Phone'
                }
              },
              {
                key: 'isdn',
                type: 'input',
                templateOptions: {
                  label: 'ISDN'
                }
              },
              {
                key: 'fax',
                type: 'input',
                templateOptions: {
                  label: 'Fax'
                }
              },
              {
                key: 'email',
                type: 'input',
                templateOptions: {
                  label: 'Email'
                }
              },
              {
                key: 'web',
                type: 'input',
                templateOptions: {
                  label: 'Website'
                }
              }
            ]
          }
        ]
      }
    ];

    this.entityrooturl = '/admin/companies';
  }

  ngOnInit() {
    // Load the parent values if there's a parentid
    this.parentid = this.route.snapshot.paramMap.get('parentid') ? this.route.snapshot.paramMap.get('parentid') : null;
    super.ngOnInit();
  }

  getModelAndConfigureDynamicFields(entityid: string = '') {
    this.httpCrud.getEntity(entityid).subscribe(data => {
      this.model = data.results;
      this.model.previousFullnr = this.model.fullnr;
      this.updatePrefixTitle = this.model.base_fkid === null ? 'Edit company:' : 'Edit sub-company:';
      this.sectionTitle = `${this.updatePrefixTitle} ${this.model.label}`;
      this.setReady();
    });
  }

  getAndConfigureEmptyDynamicFields() {
    // copy parent fields when creating a new sub-company
    if (this.parentid !== null) {
      // create from parent id
      const queryParent = this.companyService.getEntity(this.parentid);
      queryParent.subscribe((allresults) => {
        const parentCompany = allresults.results;

        // Use only values from entity form config
        this.model = parentCompany;
        delete this.model.id;
        this.model.variantlabel = '';
        this.model.nr = '';
        this.model.base_fkid = this.parentid;

        // Sets create entity title
        this.createSectionTitle = 'Create sub-company of ' + parentCompany.label;
        this.sectionTitle = this.createSectionTitle;
        this.setReady();
      });
    } else {
      this.createSectionTitle = 'Create company';
      this.sectionTitle = this.createSectionTitle;
      this.model.base_fkid = null;
      this.setReady();
    }
  }

  initCountryList = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    this.marketService.getEntities().subscribe(data => {
      typedField.templateOptions.options = data.results;
    });
  }
}
